import React, {useState, useEffect} from "react"
import notifyToast from "../../../components/Toast/Toast"
import {ToastContainer} from "react-toastify"
import TitleComponent from "../../../components/TitleComponent/TitleComponent"
import QrCodeScanner from "../../../components/QrCodeScanner/QrCodeScanner"
import {sredstvoInfo} from "../../../api/fmkNalozi"
import {useNavigate, useParams} from "react-router-dom"
import {fetchVisljuskarData, saveViljuskarData, updateVisljuskarData} from "../../../api/viljuskari"
import clsx from "clsx";

const ViljuskariDetails: React.FC = () => {
    const {id} = useParams<{ id: string }>()
    const IdFromUrl = Number(id)

    const [loading, setLoading] = useState(false)
    const [naziv, setNaziv] = useState("")
    const [pocetakSati, setPocetakSati] = useState("")
    const [sredstvoId, setSredstvoId] = useState("")
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        BrojSatiPocetak: "",
        BrojSatiKraj: "",
        ProvjerioUlje: false,
        ProvjerioVodu: false,
        ProvjerioHidrol: false,
        sredstvo: "",
        SredstvoId: "",
    })

    const isStartMode = !IdFromUrl
    const assetFound = !!naziv && !!sredstvoId
    const canStart = assetFound && String(formData.BrojSatiPocetak ?? "").length > 0
    const canFinish = String(formData.BrojSatiKraj ?? "").length > 0

    useEffect(() => {
        const fetchData = async () => {
            if (IdFromUrl) {
                try {
                    const data = await fetchVisljuskarData(IdFromUrl)
                    if (data) {
                        setPocetakSati(data.BrojSatiPocetak ?? "")
                    }
                } catch (error) {
                    console.error("Error fetching data:", error)
                }
            }
        }
        fetchData()
    }, [IdFromUrl])

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value, type, checked} = event.target
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }))

        if (name === "sredstvo" && value.length >= 3) {
            checkInventurniBroj(value)
        }
    }

    const handleQrScan = (data: string) => {
        setFormData((prevData) => ({...prevData, sredstvo: data}))
        checkInventurniBroj(data)
    }

    const checkInventurniBroj = async (invBroj: string) => {
        try {
            const data = await sredstvoInfo({invBroj})
            if (data) {
                setNaziv(data.SredstvoNaziv)
                setSredstvoId(data.SredstvoId)
                setFormData((prevData) => ({
                    ...prevData,
                    sredstvo: invBroj,
                    SredstvoId: data.SredstvoId,
                }))
            } else {
                setNaziv("")
                setSredstvoId("")
                setFormData((prevData) => ({
                    ...prevData,
                    sredstvo: invBroj,
                    SredstvoId: "",
                }))
            }
        } catch (error) {
            console.error("Error fetching data:", error)
            setNaziv("")
            setSredstvoId("")
            setFormData((prevData) => ({
                ...prevData,
                sredstvo: invBroj,
                SredstvoId: "",
            }))
        }
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        setLoading(true)
        try {
            let response
            if (IdFromUrl) {
                const {BrojSatiKraj} = formData
                response = await updateVisljuskarData({BrojSatiKraj}, IdFromUrl)
            } else {
                response = await saveViljuskarData(formData)
            }

            if (response.error === 0) {
                notifyToast(true, response.message)
                setTimeout(() => {
                    navigate(-2)
                }, 2000)
            } else {
                notifyToast(false, response.message || "An unexpected error occurred.")
            }
        } catch (error: any) {
            console.error("Error: ", error)
            notifyToast(false, error.response?.data?.message || "An unexpected error occurred.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="row">
            <ToastContainer />

            <div className="card mb-5 mb-xl-10 col-12">
                <div
                    className="card-header border-0 cursor-pointer"
                    role="button"
                    data-bs-target="#kt_account_profile_details"
                    aria-expanded="true"
                    aria-controls="kt_account_profile_details"
                >
                    <div className="card-title m-0 d-flex flex-column">
                        <TitleComponent name={isStartMode ? "Viljuškar - Start" : "Viljuškar - Kraj"} />
                        <div className="text-muted fs-7 mt-1">
                            {isStartMode
                                ? "1) Skeniraj ili upiši inventurni broj  2) Provjeri da se pojavi naziv  3) Unesi početne sate  4) Označi dnevne provjere  5) Klikni Start"
                                : "Unesi radne sate kraj i klikni Kraj"}
                        </div>
                    </div>
                </div>

                <div id="kt_account_profile_details" className="collapse show">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="card-body border-top p-9">
                            {/* INFO BOX */}
                            <div className={`alert ${isStartMode ? "alert-info" : "alert-warning"} mb-5`}>
                                <div className="fw-bold mb-1">{isStartMode ? "Start zapisa" : "Završetak zapisa"}</div>
                                <div className="mb-0">
                                    {isStartMode ? (
                                        <span>
                      Najlakše: <b>skeniraj QR</b>, pa provjeri naziv sredstva. Tek onda unesi početne sate.
                    </span>
                                    ) : (
                                        <span>
                      Provjeri početne sate i unesi <b>radne sate kraj</b> prije završetka.
                    </span>
                                    )}
                                </div>
                            </div>

                            <div className="row g-4">
                                <div className="col-lg-6 col-sm-12">
                                    {/* START MODE */}
                                    {isStartMode && (
                                        <>
                                            {/* STEP 1: Scan / manual */}
                                            <div className="card border-0 shadow-sm mb-4">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <div className="fw-bold">1) Skeniraj ili upiši inventurni broj</div>
                                                        <span className="badge bg-light text-dark border">Korak 1</span>
                                                    </div>

                                                    <div className="row g-3 align-items-center">
                                                        <div className="col-12 col-md-3">
                                                            <div className="d-grid">
                                                                <QrCodeScanner onScan={handleQrScan} />
                                                            </div>
                                                            <div className="text-muted fs-8 mt-2">
                                                                Skeniraj QR kod
                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-md-9">
                                                            <input
                                                                type="text"
                                                                placeholder="Inventurni broj (npr. 100234)"
                                                                name="sredstvo"
                                                                value={formData.sredstvo}
                                                                onChange={handleInputChange}
                                                                className="form-control form-control-lg"
                                                            />
                                                            <div className="form-text">
                                                                Nakon unosa, sistem automatski traži sredstvo.
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Asset feedback */}
                                                    <div className="mt-3">
                                                        {formData.sredstvo ? (
                                                            assetFound ? (
                                                                <div className="alert alert-success mb-0 py-3">
                                                                    <div className="fw-bold">Sredstvo pronađeno</div>
                                                                    <div className="fs-6">{naziv}</div>
                                                                </div>
                                                            ) : (
                                                                <div className="alert alert-warning mb-0 py-3">
                                                                    <div className="fw-bold">Sredstvo nije pronađeno</div>
                                                                    <div className="text-muted fs-7">
                                                                        Provjeri inventurni broj (da li si pogriješio cifru).
                                                                    </div>
                                                                </div>
                                                            )
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* STEP 2: Start hours */}
                                            <div className="card border-0 shadow-sm mb-4">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <div className="fw-bold">2) Unesi radne sate (početak)</div>
                                                        <span className="badge bg-light text-dark border">Korak 2</span>
                                                    </div>

                                                    <input
                                                        type="number"
                                                        placeholder="Radni sati početak"
                                                        name="BrojSatiPocetak"
                                                        value={formData.BrojSatiPocetak}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                    />
                                                    <div className="form-text">
                                                        Upiši stanje brojača sa viljuškara prije starta.
                                                    </div>
                                                </div>
                                            </div>

                                            {/* STEP 3: Daily checks */}
                                            <div className="card border-0 shadow-sm mb-4">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <div className="fw-bold">3) Dnevne provjere viljuškara</div>
                                                        <span className="badge bg-light text-dark border">Korak 3</span>
                                                    </div>

                                                    <div className="row g-3">
                                                        <div className="col-12">
                                                            <label
                                                                className={clsx(
                                                                    "w-100 border rounded p-4 d-flex align-items-center justify-content-between",
                                                                    formData.ProvjerioVodu ? "border-success bg-light" : "border-gray-300"
                                                                )}
                                                                style={{cursor: "pointer"}}
                                                            >
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="ProvjerioVodu"
                                                                        checked={formData.ProvjerioVodu}
                                                                        onChange={handleInputChange}
                                                                        className="form-check-input"
                                                                        style={{transform: "scale(1.4)"}}
                                                                    />
                                                                    <div>
                                                                        <div className="fw-bold">Voda provjerena</div>
                                                                        <div className="text-muted fs-7">Provjeri nivo vode / rashladne tečnosti</div>
                                                                    </div>
                                                                </div>
                                                                <span className={clsx("badge", formData.ProvjerioVodu ? "bg-success" : "bg-secondary")}>
                                  {formData.ProvjerioVodu ? "OK" : "Nije"}
                                </span>
                                                            </label>
                                                        </div>

                                                        <div className="col-12">
                                                            <label
                                                                className={clsx(
                                                                    "w-100 border rounded p-4 d-flex align-items-center justify-content-between",
                                                                    formData.ProvjerioUlje ? "border-success bg-light" : "border-gray-300"
                                                                )}
                                                                style={{cursor: "pointer"}}
                                                            >
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="ProvjerioUlje"
                                                                        checked={formData.ProvjerioUlje}
                                                                        onChange={handleInputChange}
                                                                        className="form-check-input"
                                                                        style={{transform: "scale(1.4)"}}
                                                                    />
                                                                    <div>
                                                                        <div className="fw-bold">Ulje provjereno</div>
                                                                        <div className="text-muted fs-7">Provjeri nivo ulja i eventualna curenja</div>
                                                                    </div>
                                                                </div>
                                                                <span className={clsx("badge", formData.ProvjerioUlje ? "bg-success" : "bg-secondary")}>
                                  {formData.ProvjerioUlje ? "OK" : "Nije"}
                                </span>
                                                            </label>
                                                        </div>

                                                        <div className="col-12">
                                                            <label
                                                                className={clsx(
                                                                    "w-100 border rounded p-4 d-flex align-items-center justify-content-between",
                                                                    formData.ProvjerioHidrol ? "border-success bg-light" : "border-gray-300"
                                                                )}
                                                                style={{cursor: "pointer"}}
                                                            >
                                                                <div className="d-flex align-items-center gap-3">
                                                                    <input
                                                                        type="checkbox"
                                                                        name="ProvjerioHidrol"
                                                                        checked={formData.ProvjerioHidrol}
                                                                        onChange={handleInputChange}
                                                                        className="form-check-input"
                                                                        style={{transform: "scale(1.4)"}}
                                                                    />
                                                                    <div>
                                                                        <div className="fw-bold">Hidrol provjeren</div>
                                                                        <div className="text-muted fs-7">Provjeri hidrauliku / crijeva / curenja</div>
                                                                    </div>
                                                                </div>
                                                                <span className={clsx("badge", formData.ProvjerioHidrol ? "bg-success" : "bg-secondary")}>
                                  {formData.ProvjerioHidrol ? "OK" : "Nije"}
                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Start Button */}
                                            <div className="card border-0 shadow-sm">
                                                <div className="card-body">
                                                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                                                        <div className="text-muted fs-7">
                                                            {!assetFound && formData.sredstvo ? (
                                                                <span>Ne možete startati dok sistem ne pronađe sredstvo.</span>
                                                            ) : !formData.BrojSatiPocetak ? (
                                                                <span>Unesite radne sate početak prije starta.</span>
                                                            ) : (
                                                                <span>Spremno za start.</span>
                                                            )}
                                                        </div>

                                                        <button
                                                            type="submit"
                                                            className="btn btn-success btn-lg px-8"
                                                            disabled={loading || !canStart}
                                                        >
                                                            {!loading && "Start"}
                                                            {loading && (
                                                                <span className="indicator-progress" style={{display: "block"}}>
                                  Please wait...{" "}
                                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {/* FINISH MODE */}
                                    {!isStartMode && (
                                        <>
                                            <div className="card border-0 shadow-sm mb-4">
                                                <div className="card-body">
                                                    <div className="fw-bold mb-2">Radni sati početak</div>
                                                    <div className="alert alert-secondary mb-0">
                                                        <span className="fw-bold fs-5">{pocetakSati}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card border-0 shadow-sm mb-4">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <div className="fw-bold">Unesi radne sate (kraj)</div>
                                                        <span className="badge bg-light text-dark border">Korak</span>
                                                    </div>

                                                    <input
                                                        type="number"
                                                        placeholder="Radni sati kraj"
                                                        name="BrojSatiKraj"
                                                        value={formData.BrojSatiKraj}
                                                        onChange={handleInputChange}
                                                        className="form-control form-control-lg"
                                                    />
                                                    <div className="form-text">
                                                        Upiši stanje brojača nakon završetka rada.
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="card border-0 shadow-sm">
                                                <div className="card-body">
                                                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                                                        <div className="text-muted fs-7">
                                                            {!formData.BrojSatiKraj ? <span>Unesite radne sate kraj prije završetka.</span> : <span>Spremno za završetak.</span>}
                                                        </div>

                                                        <button
                                                            type="submit"
                                                            className="btn btn-danger btn-lg px-8"
                                                            disabled={loading || !canFinish}
                                                        >
                                                            {!loading && "Kraj"}
                                                            {loading && (
                                                                <span className="indicator-progress" style={{display: "block"}}>
                                  Please wait...{" "}
                                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ViljuskariDetails
